import { Classes, SectionCard } from "@blueprintjs/core";
import { CustomUpgrade } from "in_queue/contexts/CustomUpgradesContext";
import { ScenarioMetadata } from "in_queue/types/scenarioType";
import { useState } from "react";
import { TextLinkButton } from "../../common/TextLinkButton";
import { CustomUpgradeDialog } from "../../CustomUpgrades/CustomUpgradeDialog";
import { ScenarioAssumptionsSection } from "../ScenarioAssumptions";
import css from "../ScenarioAssumptions.module.scss";

export const CustomUpgradesSection: React.FC<{
    scenario: ScenarioMetadata;
    allCustomUpgrades: CustomUpgrade[];
}> = ({ scenario, allCustomUpgrades }) => {
    const customUpgradeIdsForScenario = scenario.customUpgradeId
        ? [scenario.customUpgradeId]
        : [];

    const customUpgradesForScenario = allCustomUpgrades.filter(
        (customUpgrade) =>
            customUpgradeIdsForScenario.find((id) => id === customUpgrade.id)
    );

    const [openCustomUpgrade, setOpenCustomUpgrade] =
        useState<CustomUpgrade | null>(null);

    const numCustomUpgrades = customUpgradesForScenario.length;

    const content = numCustomUpgrades ? (
        customUpgradesForScenario.map((customUpgrade) => {
            return (
                <SectionCard
                    key={customUpgrade.id}
                    padded={false}
                    className={css["scenario-assumptions-card"]}
                >
                    <span>
                        Successfully applied{" "}
                        <TextLinkButton
                            text={` ${customUpgrade.name}`}
                            onClick={() => setOpenCustomUpgrade(customUpgrade)}
                        />
                    </span>
                </SectionCard>
            );
        })
    ) : (
        <SectionCard
            padded={false}
            className={`${css["scenario-assumptions-card"]} ${Classes.TEXT_MUTED}`}
        >
            No custom upgrades have been provided for this scenario.
        </SectionCard>
    );

    return (
        <ScenarioAssumptionsSection
            section="customUpgrades"
            title={<>Custom Upgrades ({numCustomUpgrades})</>}
        >
            {openCustomUpgrade && (
                <CustomUpgradeDialog
                    isOpen={!!openCustomUpgrade}
                    onClose={() => setOpenCustomUpgrade(null)}
                    upgrade={openCustomUpgrade}
                    showArchiveButton={false}
                />
            )}
            {content}
        </ScenarioAssumptionsSection>
    );
};
